import styled from "styled-components";
import color from "../../constants/color";

export const Container = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width};
`;

export const Placeholder = styled.p`
  margin: 0;
`;

interface LabelProps {
  color: string;
}

export const Label = styled.label<LabelProps>`
  font-size: 14px;
  font-family: Inter;
  margin-bottom: 8px;
  color: ${(props) => props.color || color.grey1};
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const Helper = styled.small`
  font-size: 12px;
  color: red;
  font-family: Inter;
  margin-left: 12px;
  margin-top: 4px;
`;
